import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import addonSearchReducer, { AddonSearchState } from './addonSearch';
export * from './addonSearch';
export type AddonState = {
  searches: Record<string, AddonSearchState>;
};
const slice = createSlice({
  name: 'addon',
  initialState: {} as AddonState,
  reducers: {
    clearSearch: (state, action: PayloadAction<{
      searchId: string;
    }>) => {
      const searchId = action?.payload?.searchId;
      if (state?.searches?.[searchId]) {
        return {
          ...state,
          searches: {
            ...state.searches,
            [searchId]: undefined
          }
        };
      }
      return state;
    }
  },
  extraReducers(builder) {
    builder.addMatcher(action => action.type?.startsWith('addonSearch') && action.type.includes('pending'), (state, action) => {
      const searchId = action.meta.arg.searchId ?? action.meta.requestId;
      if (searchId) {
        const currentState: AddonSearchState = state?.searches?.[searchId] ?? {
          searchId
        };
        currentState.inProgress = true;
        const newSearches = {
          ...state.searches,
          [searchId]: currentState
        };
        return {
          ...state,
          searches: newSearches
        };
      }
    }).addMatcher(action => action.type?.startsWith('addonSearch') && !action.type.includes('pending'), (state, action) => {
      const searchId = action?.['payload']?.['searchId'];
      if (searchId) {
        const currentState: AddonSearchState = state?.searches?.[searchId] ?? {
          searchId
        };
        const newState = addonSearchReducer(currentState, action);
        const newSearches = Object.assign({}, ...[state?.searches, {
          [searchId]: newState
        }].filter(Boolean));
        return {
          ...state,
          searches: newSearches
        };
      }
      return state;
    });
  }
});
export const {
  clearSearch
} = slice.actions;
const reducer = slice.reducer;
export default reducer;